import { render, staticRenderFns } from "./TrackingBehaviorWarehouse.vue?vue&type=template&id=4f704812&scoped=true"
import script from "./TrackingBehaviorWarehouse.vue?vue&type=script&lang=js"
export * from "./TrackingBehaviorWarehouse.vue?vue&type=script&lang=js"
import style0 from "./TrackingBehaviorWarehouse.vue?vue&type=style&index=0&id=4f704812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f704812",
  null
  
)

export default component.exports